import React, { useState } from 'react'

const TABS = ['Description', 'Feeding Guide', 'Additional Info', 'Shipping Info']
// Add product as an input variable when feeding guide and description are reenabled
const ProductTabs = ({  description, isPetProduct }) => {
  const [activeTab, setActiveTab] = useState('Description')

  const accent = isPetProduct ? 'text-red-600 border-red-500' : 'text-emerald-700 border-emerald-600'
  // const accentBg = isPetProduct ? 'bg-red-50' : 'bg-emerald-50'

  return (
    <div className="mt-10 border-t border-gray-200 pt-8">
      <div className="flex gap-0 border-b border-gray-200">
        {TABS.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-5 py-3 text-sm font-semibold transition ${
              activeTab === tab
                ? `${accent} border-b-2 -mb-px`
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="py-6">
        {activeTab === 'Description' && (
          <div>
            {description ? (
              <div
                className="prose prose-sm max-w-none text-gray-600 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            ) : (
              <p className="text-gray-400 italic">No description available.</p>
            )}
          </div>
        )}

        {activeTab === 'Feeding Guide' && (
          <div>
            {/* {product.feedingGuide && product.feedingGuide.length > 0 ? (
              // <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead>
                    <tr className={`${accentBg}`}>
                      <th className="px-4 py-3 text-left font-semibold text-gray-700">Cat/Dog Weight</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-700">Ideal Weight</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-700">Overweight</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {product.feedingGuide.map((row, i) => (
                      <tr key={i}>
                        <td className="px-4 py-2 text-gray-600">{row.weight}</td>
                        <td className="px-4 py-2 text-gray-600">{row.idealWeight}</td>
                        <td className="px-4 py-2 text-gray-600">{row.overweight}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : ( */}
              <p className="text-gray-400 italic">Feeding guide coming soon.</p>
            {/* )} */}
          </div>
        )}

        {activeTab === 'Additional Info' && (
          <div>
            {/* {product.additionalInfo ? (
              <table className="min-w-full divide-y divide-gray-200 text-sm">
                <tbody className="divide-y divide-gray-100">
                  {Object.entries(product.additionalInfo).map(([key, value]) => {
                    if (!value) return null
                    const label = key
                      .replace(/([A-Z])/g, ' $1')
                      .replace(/^./, (s) => s.toUpperCase())
                    return (
                      <tr key={key}>
                        <td className="px-4 py-2 font-semibold text-gray-700 w-1/3">{label}</td>
                        <td className="px-4 py-2 text-gray-600">{value}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            ) : ( */}
              <p className="text-gray-400 italic">Additional information coming soon.</p>
            {/* )} */}
          </div>
        )}

        {activeTab === 'Shipping Info' && (
          <div className="text-sm text-gray-600 leading-relaxed space-y-6">
            <div>
              <h4 className="text-lg font-bold text-gray-900">Our Delivery Options</h4>
              <p className="mt-3">
                We want to make pet parenting as easy for you so that you can spend more quality time with your furry friends. See below for our delivery costs for your area:
              </p>
              <p className="mt-3">
                Courier deliveries take 2&ndash;5 working days depending on the order&rsquo;s destination.
              </p>
              <div className="mt-4 space-y-4">
                <div>
                  <p className="font-semibold text-gray-800">Main Area Deliveries</p>
                  <ul className="mt-1 list-inside list-disc space-y-0.5">
                    <li>Orders under R500: R55</li>
                    <li>Orders over R500: <span className="font-semibold text-emerald-600">FREE</span></li>
                  </ul>
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Regional Area Deliveries</p>
                  <ul className="mt-1 list-inside list-disc space-y-0.5">
                    <li>Orders under R1,000: R85</li>
                    <li>Orders over R1,000: <span className="font-semibold text-emerald-600">FREE</span></li>
                  </ul>
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Outlying Area Deliveries</p>
                  <ul className="mt-1 list-inside list-disc space-y-0.5">
                    <li>All orders: R85</li>
                  </ul>
                </div>
              </div>
            </div>

            <hr className="border-gray-200" />

            <div>
              <h4 className="text-lg font-bold text-gray-900">Available Delivery Types</h4>
              <p className="mt-3">
                Depending on your delivery area, you will be able to select between the below delivery types:
              </p>
              <div className="mt-4 space-y-4">
                <div className="rounded-lg border border-gray-200 bg-white p-5">
                  <h5 className="font-semibold text-gray-900">Express Delivery</h5>
                  <p className="mt-1 text-gray-600">Next day delivery</p>
                </div>
                <div className="rounded-lg border border-gray-200 bg-white p-5">
                  <h5 className="font-semibold text-gray-900">Booked delivery</h5>
                  <p className="mt-1 text-gray-600">Option to choose specific delivery day based on your availability</p>
                </div>
                <div className="rounded-lg border border-gray-200 bg-white p-5">
                  <h5 className="font-semibold text-gray-900">Courier Delivery</h5>
                  <p className="mt-1 text-gray-600">Standard courier delivery in 1&ndash;7 working days depending on your area.</p>
                </div>
              </div>
              <p className="mt-4">
                For more information on delivery please contact our customer service by email to{' '}
                <a href="mailto:info@arrandarr.com" className="text-emerald-600 hover:text-emerald-700">info@arrandarr.com</a>.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ProductTabs
